import axios from 'axios';

export const openApi = axios.create({
  baseURL: import.meta.env.VITE_URL_API,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
});
